module.exports = __webpack_public_path__ + "static/media/PushtimargImage13.4186b131.jpg";